<template>
  <div class="sidebar">
    <div class="text-box">
      <img
        @click="handleHomeClick"
        class="display-img"
        src="../../../assets/heartbeatfamlogo.png"
        alt="heartbeat"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  methods: {
    handleHomeClick() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
$bp-sm: 576px;
$bp-md: 768px;
$bp-tab: 862px;
$bp-lg: 992px;
$bp-lap: 1024px;
$bp-xl: 1200px;

.sidebar {
  padding: 4rem 3rem;
  width: 34%;
  float: left;
  height: 100vh;
  box-sizing: border-box;

  .text-box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .display-img {
      max-width: 100%;
      max-height: 100%;
      cursor: pointer;
    }
  }
}

@media (max-width: $bp-lap) {
  .sidebar {
    width: 40%;
    padding: 4rem 2rem;
  }
}

@media (max-width: $bp-tab) {
  .sidebar {
    width: 100%;
    height: auto;
    padding: 4rem;
    float: none;

    .text-box {
      height: auto;

      .display-img {
        max-height: 200px;
        margin: 0 auto;
      }
    }
  }
}

@media (max-width: $bp-sm) {
  .sidebar {
    padding: 2rem;

    .text-box {
      .display-img {
        max-height: 150px;
      }
    }
  }
}
</style>
